import React from 'react';

export const validarFechasExperiencia = (inicioObj, finObj) => {
  if (!inicioObj.mes || !inicioObj.año || !finObj.mes || !finObj.año) {
    return null;
  }

  const inicio = `${inicioObj.año}-${inicioObj.mes}`;
  const fin = `${finObj.año}-${finObj.mes}`;

  const fechaInicio = new Date(inicio + '-01');
  const fechaFin = new Date(fin + '-01');
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);

  if (fechaInicio > fechaFin) {
    return 'La fecha de inicio no puede ser mayor que la fecha de finalización.';
  }
  if (fechaFin > hoy) {
    return 'La fecha de finalización no puede ser mayor que la fecha actual.';
  }
  return null;
};

export const validateField = (name, value) => {
  switch (name) {
    case 'cedula':
    case 'telefono':
      return /^\d+$/.test(value) ? '' : 'Este campo solo debe contener números';

    case 'email':
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? '' : 'Ingrese un email válido';

    case 'porcentajeDiscapacidad':
      if (value && (value < 0 || value > 100)) {
        return 'El porcentaje debe estar entre 0 y 100';
      }
      return '';

    case 'preferenciaSalarial':
      return /^\d+$/.test(value) ? '' : 'La preferencia salarial debe ser un número';

    default:
      return '';
  }
};

export const validateAllFields = (formData) => {
  const errors = {};

  const requiredFields = [
    'nombre', 'apellido', 'nacionalidad', 'fechaNacimiento', 'estadoCivil',
    'tipoDocumento', 'cedula', 'genero', 'telefono', 'provincia', 'canton',
    'direccion', 'email', 'preferenciaSalarial', 'cv', 'trabajadoEnConduto'
  ];

  requiredFields.forEach(field => {
    if (!formData[field] || formData[field].toString().trim() === '') {
      errors[field] = 'Este campo es obligatorio';
    }
  });

  const fieldValidations = {
    cedula: validateField('cedula', formData.cedula),
    telefono: validateField('telefono', formData.telefono),
    email: validateField('email', formData.email),
    porcentajeDiscapacidad: validateField('porcentajeDiscapacidad', formData.porcentajeDiscapacidad),
    preferenciaSalarial: validateField('preferenciaSalarial', formData.preferenciaSalarial)
  };

  Object.keys(fieldValidations).forEach(field => {
    if (fieldValidations[field] && formData[field]) {
      errors[field] = fieldValidations[field];
    }
  });

  if (formData.discapacidad === 'Sí') {
    if (formData.porcentajeDiscapacidad === '' || formData.porcentajeDiscapacidad === undefined || formData.porcentajeDiscapacidad === null) {
      errors.porcentajeDiscapacidad = 'Este campo es obligatorio';
    }
  }

  formData.formacionesAcademicas.forEach((formacion, index) => {
    const formacionFields = ['titulo', 'tipoEstudio', 'areaEstudio', 'institucion', 'estadoEstudio', 'fechaInicioEstudio', 'fechaFinEstudio'];
    formacionFields.forEach(field => {
      if (!formacion[field] || formacion[field].toString().trim() === '') {
        errors[`formacion_${index}_${field}`] = `Formación ${index + 1}: ${field} es obligatorio`;
      }
    });
  });

  formData.idiomas.forEach((idioma, index) => {
    if (!idioma.idioma || idioma.idioma.toString().trim() === '') {
      errors[`idioma_${index}_idioma`] = `Idioma ${index + 1}: idioma es obligatorio`;
    }
    if (idioma.idioma === "Otros" && (!idioma.otroIdioma || idioma.otroIdioma.toString().trim() === '')) {
      errors[`idioma_${index}_otroIdioma`] = `Idioma ${index + 1}: debe especificar el idioma`;
    }
    if (!idioma.nivelEscrito || idioma.nivelEscrito.toString().trim() === '') {
      errors[`idioma_${index}_nivelEscrito`] = `Idioma ${index + 1}: nivel escrito es obligatorio`;
    }
    if (!idioma.nivelOral || idioma.nivelOral.toString().trim() === '') {
      errors[`idioma_${index}_nivelOral`] = `Idioma ${index + 1}: nivel oral es obligatorio`;
    }
  });

  formData.experiencias.forEach((experiencia, index) => {
    const experienciaCamposRequeridos = ['empresa', 'actividadEmpresa', 'nivelExperiencia', 'paisEmpresa', 'descripcionResponsabilidad'];

    experienciaCamposRequeridos.forEach(field => {
      if (!experiencia[field] || experiencia[field].toString().trim() === '') {
        errors[`experiencia_${index}_${field}`] = `Experiencia ${index + 1}: ${field} es obligatorio`;
      }
    });

    if (!experiencia.puesto || experiencia.puesto.toString().trim() === '') {
      errors[`experiencia_${index}_puesto`] = 'El puesto es obligatorio';
    }

    if (experiencia.puesto === 'Otros' && (!experiencia.otroPuesto || experiencia.otroPuesto.toString().trim() === '')) {
      errors[`experiencia_${index}_otroPuesto`] = 'Debe especificar el puesto';
    }

    if (!experiencia.fechaInicioExperiencia.mes) {
      errors[`experiencia_${index}_fechaInicioMes`] = 'El mes de inicio es requerido';
    }
    if (!experiencia.fechaInicioExperiencia.año) {
      errors[`experiencia_${index}_fechaInicioAnio`] = 'El año de inicio es requerido';
    }
    if (!experiencia.fechaFinalizacionExperiencia.mes) {
      errors[`experiencia_${index}_fechaFinMes`] = 'El mes de finalización es requerido';
    }
    if (!experiencia.fechaFinalizacionExperiencia.año) {
      errors[`experiencia_${index}_fechaFinAnio`] = 'El año de finalización es requerido';
    }

    if (!experiencia.personasCargo && experiencia.personasCargo !== 0) {
      errors[`experiencia_${index}_personasCargo`] = 'El campo personas a cargo es obligatorio';
    }

    if (experiencia.fechaInicioExperiencia.mes && experiencia.fechaInicioExperiencia.año &&
      experiencia.fechaFinalizacionExperiencia.mes && experiencia.fechaFinalizacionExperiencia.año) {

      const errorFechas = validarFechasExperiencia(
        experiencia.fechaInicioExperiencia,
        experiencia.fechaFinalizacionExperiencia
      );

      if (errorFechas) {
        errors[`experiencia_${index}_fechaInicio`] = errorFechas;
        errors[`experiencia_${index}_fechaFinalizacion`] = errorFechas;
      }
    }
  });

  return errors;
};

export const ErrorMessage = ({ message }) => (
  <div className="alert alert-danger d-flex align-items-center" role="alert">
    <div>{message}</div>
  </div>
);

export const SuccessMessage = ({ message, onClose }) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <div className="alert alert-success alert-dismissible fade show" role="alert">
      <div>{message}</div>
      <button type="button" className="btn-close" onClick={onClose}></button>
    </div>
  );
};